export enum FriendsPathsEnum {
  FRIENDS = "/friends",
  MY_FRIENDS = "/friends/list",
  REQUEST_FRIENDS = "/friends/requests",
  SUGGESTIONS = "/friends/suggestions",
  FIND_FRIENDS = "/friends/find",
}

export const FRIEND_ACTION_TYPES = {
  ADD_FRIEND: "ADD_FRIEND",
  ACCEPT_REQUEST: "ACCEPT_REQUEST",
  DECLINE_REQUEST: "DECLINE_REQUEST",
  CANCEL_REQUEST: "CANCEL_REQUEST",
  UNFRIEND: "UNFRIEND",
  BLOCK_USER: "BLOCK_USER",
} as const;

export const FRIEND_REQUEST_STATUS = {
  pending: "Đang chờ",
  accepted: "Đã chấp nhận",
  declined: "Đã từ chối",
} as const;
